import { render, staticRenderFns } from "./RetailDetailExpand.vue?vue&type=template&id=20ea71e0&scoped=true&"
import script from "./RetailDetailExpand.vue?vue&type=script&lang=js&"
export * from "./RetailDetailExpand.vue?vue&type=script&lang=js&"
import style0 from "./RetailDetailExpand.vue?vue&type=style&index=0&id=20ea71e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ea71e0",
  null
  
)

export default component.exports